export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const GOOGLE_LOGIN_CLIENT_ID = process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID;
export const WEBOPS_URL = process.env.REACT_APP_WEBOPS_URL || 'http://localhost:3001';
/**
 * Optional explicit backend URL override. Used by the dockerized E2E build so the app
 * can reach the backend by its compose service name (e.g. http://backend:5001/). Empty
 * in normal builds, where serverUrl() falls back to the per-environment hosts below.
 */
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;

/**
 * @description Task substages (e.g. Premium Ops Review).
 */
export const TASK_SUBSTAGES = {
  PREMIUM_OPS_REVIEW: 'PREMIUM_OPS_REVIEW',
  EMAIL_INBOX: 'EMAIL_INBOX',
  MULTISTATE_RETURN: 'MULTISTATE_RETURN',
  EA_REVIEW: 'EA_REVIEW',
  BLOCKED: 'BLOCKED',
  EMAIL_OUTBOX: 'EMAIL_OUTBOX',
  PAST_YEAR_RETURN: 'PAST_YEAR_RETURN',
  HBS_TO_DO: 'HBS_TO_DO',
  HBS_DONE: 'HBS_DONE'
};

// task list
export const TASKS_PER_PAGE = 15;
export const CURRENT_TAX_YEAR = 2025;
export const AVAILABLE_TAX_YEARS = [2025, 2024, 2023, 2022, 2021, 2020];
/** Default stages to filter by for non-eng users */
export const DEFAULT_STAGES = ['Ops Review', 'Tax Expert Escalations', 'Final Review', 'Filed with IRS'];
/** Default stages to filter by for eng users */
export const ENG_DEFAULT_STAGES = [
  'Ops Review',
  'Tax Expert Escalations',
  'Final Review',
  'Filed with IRS',
  'eng escalation'
];
export const ALL_STAGES = [
  'Not Started',
  'Ops Review',
  'Tax Expert Escalations',
  'Confirm Amounts',
  'Final Review',
  'Filed with IRS',
  'Accepted by IRS',
  'user escalation',
  'eng escalation',
  'Purgatory',
  'DO NOT FILE',
  'Pre-Submit'
];
export const ALL_SUBSTAGES = [
  { value: TASK_SUBSTAGES.PREMIUM_OPS_REVIEW, label: 'Premium Ops Review' },
  { value: TASK_SUBSTAGES.EMAIL_OUTBOX, label: 'Email Outbox' },
  { value: TASK_SUBSTAGES.EMAIL_INBOX, label: 'Email Inbox' },
  { value: TASK_SUBSTAGES.MULTISTATE_RETURN, label: 'Multistate Return' },
  { value: TASK_SUBSTAGES.EA_REVIEW, label: 'EA Review' },
  { value: TASK_SUBSTAGES.BLOCKED, label: 'Blocked' },
  { value: TASK_SUBSTAGES.HBS_TO_DO, label: 'HBS To Do' },
  { value: TASK_SUBSTAGES.HBS_DONE, label: 'HBS Done' }
];
export const TASK_LIST_COLS = [
  'type',
  'stage',
  'assignee',
  'user_id',
  'ssn',
  'phone',
  'first_name',
  'last_name',
  'email',
  'updatedAt'
];
export const TASK_EXPORT_FIELDS = [
  'id',
  'stage',
  'user_id',
  'ssn',
  'first_name',
  'last_name',
  'phone',
  'email',
  'assignee',
  'update_reason',
  'last_upload',
  'last_stage_change',
  'ops_status',
  'forms',
  'state',
  'healthcare',
  'multistate',
  'validation_errors',
  'locality',
  'school_district',
  'county',
  'interest_country',
  'debit_acc_info',
  'user_facing_error_type',
  'user_facing_errors',
  'drake_notes',
  'user_esc_reason',
  'extension_status',
  'createdAt',
  'updatedAt',
  'tagged_reviewers',
  'year',
  'state_drake_notes',
  'user_esc_historic',
  'rejected_esc_historic',
  'prev_stage',
  'tax_msg_sent'
];

// task details
export const TP_INFO_COLS = [
  { displayName: 'User ID', field: 'user_id' },
  { displayName: 'Phone', field: 'phone' },
  { displayName: 'Email', field: 'email' },
  { displayName: 'First Name', field: 'first_name' },
  { displayName: 'Last Name', field: 'last_name' },
  { displayName: 'SSN', field: 'ssn' },
  { displayName: 'Assigned Tax Pro', field: 'taxProAssignment.taxProName' },
  { displayName: 'Update Reason', field: 'update_reason' },
  { displayName: 'Last Upload', field: 'last_upload' },
  { displayName: 'Last Stage Change', field: 'last_stage_change' },
  { displayName: 'Forms', field: 'forms' },
  { displayName: 'Premium Situations', field: 'premiumSituations' },
  { displayName: 'User Notes', field: 'taxNotes' },
  { displayName: 'Validation Errors', field: 'validation_errors' },
  { displayName: 'Validation Warnings', field: 'validation_warnings' },
  { displayName: 'State', field: 'state' },
  { displayName: 'Locality', field: 'locality' },
  { displayName: 'School District', field: 'school_district' },
  { displayName: 'County', field: 'county' },
  { displayName: 'Federal Amount', field: 'federal_amount' },
  { displayName: 'Multistate Amount', field: 'multistate_amount' },
  { displayName: 'Healthcare Taxpayer', field: 'healthcare_taxpayer' },
  { displayName: 'Healthcare Spouse', field: 'healthcare_spouse' },
  { displayName: 'Healthcare Dependents', field: 'healthcare_dependents' },
  { displayName: 'Multistate Residency', field: 'multistate_residency' },
  { displayName: 'Multistate Address', field: 'multistate_address' },
  { displayName: 'Multistate Income', field: 'multistate_income' },
  { displayName: 'Multistate Expenses', field: 'multistate_expenses' },
  { displayName: 'Debit Account Info', field: 'debit_acc_info' },
  { displayName: 'Tax Message Sent', field: 'tax_msg_sent' }
];
export const FORM_UPLOAD_COLS = [
  { displayName: 'File Name', getValue: (_, file) => file.file_name },
  { displayName: 'Collection Type', getValue: (attempt, _) => attempt.collectionType },
  { displayName: 'Status', getValue: (attempt, _) => attempt.status },
  { displayName: 'Is Premium', getValue: (attempt, _) => (attempt.isPremium ? 'Yes' : 'No') }
];
export const SUBSTAGE_FIELDS = [
  { label: 'Premium Ops Review', name: TASK_SUBSTAGES.PREMIUM_OPS_REVIEW },
  { label: 'Email Inbox', name: TASK_SUBSTAGES.EMAIL_INBOX },
  { label: 'Multistate Return', name: TASK_SUBSTAGES.MULTISTATE_RETURN, disabled: true },
  { label: 'EA Review', name: TASK_SUBSTAGES.EA_REVIEW, disabled: true },
  { label: 'Blocked', name: TASK_SUBSTAGES.BLOCKED, special: true },
  { label: 'Email Outbox', name: TASK_SUBSTAGES.EMAIL_OUTBOX, special: true },
  { label: 'Past Year Return', name: TASK_SUBSTAGES.PAST_YEAR_RETURN, special: true },
  { label: 'HBS To Do', name: TASK_SUBSTAGES.HBS_TO_DO },
  { label: 'HBS Done', name: TASK_SUBSTAGES.HBS_DONE }
];
export const USER_ESC_TYPES = [
  { label: 'Keeper review', value: 'standard' },
  { label: 'Rejected by IRS', value: 'rejected by irs' },
  { label: 'Unable to file', value: 'DNF' }
];
export const EXTENSION_STATUSES = [
  { label: '', value: '' },
  { label: 'Filed', value: 'filed' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Error', value: 'error' },
  { label: 'Not in Drake', value: 'notInDrake' }
];
export const TASK_DETAIL_ACTIONS = {
  USER_ESCALATION: 'User Escalation',
  CONFIRM_AMOUNTS: 'Confirm Amounts',
  CONFIRM_AMOUNTS_NO_TEXT_EMAIL: 'Confirm Amounts (no text/email)',
  UPDATE_AMOUNTS: 'Update Amounts',
  FILED_WITH_IRS: 'Filed with IRS',
  ACCEPTED_BY_IRS: 'Accepted by IRS',
  UPLOAD_TAX_DATA: 'Upload Tax Data',
  UPLOAD_DEPOSIT_WITHDRAWAL_FORMS: 'Upload Deposit / Withdrawal Forms',
  UNLOCK_USER: 'Unlock User',
  MOVE_TO_TAX_EXPERT_ESC: 'Move to Tax Expert Esc',
  MOVE_TO_OPS_REVIEW: 'Move to Ops Review',
  MOVE_TO_FINAL_REVIEW: 'Move to Final Review',
  MOVE_TO_ENG_ESC: 'Move to Eng Esc',
  DO_NOT_FILE: 'DO NOT FILE'
};
export const ACTION_STAGE_MAP = {
  [TASK_DETAIL_ACTIONS.USER_ESCALATION]: [
    'ops review',
    'final review',
    'tax expert escalations',
    'filed with irs',
    'accepted by irs',
    'eng escalation',
    'user escalation'
  ],
  [TASK_DETAIL_ACTIONS.CONFIRM_AMOUNTS]: ['ops review', 'tax expert escalations', 'eng escalation'],
  [TASK_DETAIL_ACTIONS.CONFIRM_AMOUNTS_NO_TEXT_EMAIL]: ['final review', 'eng escalation'],
  [TASK_DETAIL_ACTIONS.UPDATE_AMOUNTS]: ['confirm amounts', 'eng escalation'],
  [TASK_DETAIL_ACTIONS.FILED_WITH_IRS]: ['final review', 'tax expert escalations'],
  [TASK_DETAIL_ACTIONS.ACCEPTED_BY_IRS]: ['filed with irs', 'tax expert escalations'],
  [TASK_DETAIL_ACTIONS.MOVE_TO_OPS_REVIEW]: ['tax expert escalations'],
  [TASK_DETAIL_ACTIONS.MOVE_TO_FINAL_REVIEW]: ['tax expert escalations'],
  [TASK_DETAIL_ACTIONS.MOVE_TO_TAX_EXPERT_ESC]: [
    'ops review',
    'final review',
    'filed with irs',
    'accepted by irs',
    'confirm amounts'
  ],
  [TASK_DETAIL_ACTIONS.MOVE_TO_ENG_ESC]: ['ops review', 'final review', 'tax expert escalations'],
  'Drake Upload': ['not started', 'eng escalation'],
  [TASK_DETAIL_ACTIONS.UPLOAD_TAX_DATA]: ['not started', 'eng escalation'],
  [TASK_DETAIL_ACTIONS.UPLOAD_DEPOSIT_WITHDRAWAL_FORMS]: ['eng escalation'],
  [TASK_DETAIL_ACTIONS.UNLOCK_USER]: [
    'ops review',
    'eng escalation',
    'do not file',
    'confirm amounts',
    'tax expert escalations'
  ],
  [TASK_DETAIL_ACTIONS.DO_NOT_FILE]: [
    'not started',
    'ops review',
    'tax expert escalations',
    'eng escalation',
    'final review'
  ]
};

export const RETURN_DOWNLOAD_STAGES = [
  'Confirm Amounts',
  'Filed with IRS',
  'Accepted by IRS',
  'Final Review',
  'Tax Expert Escalations'
];

export function serverUrl() {
  if (SERVER_URL) {
    return SERVER_URL;
  }
  if (REACT_APP_ENV === 'development') {
    return 'http://localhost:5001/';
  } else if (REACT_APP_ENV === 'staging') {
    return 'https://keeper-backend-staging.keepertax.com/';
  } else if (REACT_APP_ENV === 'staging-2') {
    return 'https://keeper-backend-staging-2.keepertax.com/';
  } else if (REACT_APP_ENV === 'staging-3') {
    return 'https://keeper-backend-staging-3.keepertax.com/';
  } else if (REACT_APP_ENV === 'production') {
    return 'https://keeper-backend.keepertax.com/';
  }
  throw new Error(`invalid environment: ${REACT_APP_ENV}`);
}

export function appUrl() {
  if (REACT_APP_ENV === 'development') {
    return 'http://localhost:3003';
  } else if (REACT_APP_ENV === 'staging') {
    return 'https://qdeck-staging.keepertax.com';
  } else if (REACT_APP_ENV === 'staging-2') {
    return 'https://qdeck-staging-2.keepertax.com';
  } else if (REACT_APP_ENV === 'staging-3') {
    return 'https://qdeck-staging-3.keepertax.com';
  } else if (REACT_APP_ENV === 'production') {
    return 'https://qdeck.keepertax.com';
  }
  throw new Error(`invalid environment: ${REACT_APP_ENV}`);
}

export const MIN_DRAKE_YEAR = 2024;
